/**
 * SalesOfficeLocation
 *
 * Location wrapper for the Marketing/Sales view.
 * Maps to the "Marketing" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { MarketView } from '../tycoon/MarketView';

export type SalesOfficeLocationProps = React.ComponentProps<typeof MarketView>;

export const SalesOfficeLocation: React.FC<SalesOfficeLocationProps> = (props) => {
  return (
    <LocationWrapper
      location={CampusLocation.SALES_OFFICE}
      title="Sales Office"
    >
      <MarketView {...props} />
    </LocationWrapper>
  );
};

export default SalesOfficeLocation;
